module.exports = __webpack_public_path__ + "img/84_25.bec76d15.png";